/**
 * External Dependencies
 */
 import 'bootstrap';

 $(document).ready(() => {
   // Enable popovers 🧁
    $('[data-toggle="popover"]').popover();

    $('.hamburger').click(function() {
      $(this).toggleClass('is-active');
    });

 });

 $(window).load(function(){
  if($('#hero-bg-video').length) {
    const media = document.getElementById('hero-bg-video');
    media.play();
  }

  if(document.querySelector('.is-style-homepage-hero .wp-block-gallery')) {
    let slides = document.querySelectorAll('.is-style-homepage-hero .wp-block-gallery .blocks-gallery-item');
    let interval = 4000;
    let activeSlide = 0;

    // slides[0].classList.add('show');

    setInterval(() => {
      let nextSlide = activeSlide + 1 < slides.length ? activeSlide + 1 : 0;
      
      slides[activeSlide].classList.remove('show')
      slides[activeSlide].classList.add('hide');

      slides[nextSlide].classList.add('show');
      slides[nextSlide].classList.remove('hide');

      // console.log(activeSlide);

      // update count
      activeSlide = nextSlide;
    }, interval)
  }
 });